import React from 'react';
import "./SectionArticles.scss";
import { ArticleList, ArticleFolo, AdImage, LoadButton } from '..';

const SectionArticles = ({ path }) => {
    return (
        <div className="section-articles">
            <div className="section-articles-container">
                <ArticleList>
                    <ArticleFolo
                        title="3 tips de carpinteria"
                        tag="carpinteria"
                        img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        author="El folo"
                        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam mollitia nihil tempora quae quas magnam voluptatibus dolorum, facere omnis consequatur minus fuga nulla ducimus dolore earum labore repudiandae illo eosasdfsadfkasjdklfjsadklñas ldñfjaklsñdjfñlkasdj fñlkasjdflkjasñdlkfjlkasdjflksadjfñklasd jñalsdkjfñlaskdjñflksjddsfsdfsdlkasdfsadfñjkkljñaslkdfjñlkasdjflkasdjflkñlaskdfj."
                        height="200px"
                        width="250px"
                        fontSize="1.3rem"
                        display="flex"
                        path={path}
                    />
                    <ArticleFolo
                        title="3 tips de carpinteria"
                        tag="carpinteria"
                        img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        author="El folo"
                        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam mollitia nihil tempora quae quas magnam voluptatibus dolorum, facere omnis consequatur minus fuga nulla ducimus dolore earum labore repudiandae illo eosasdfsadfkasjdklfjsadklñas ldñfjaklsñdjfñlkasdj fñlkasjdflkjasñdlkfjlkasdjflksadjfñklasd jñalsdkjfñlaskdjñflksjddsfsdfsdlkasdfsadfñjkkljñaslkdfjñlkasdjflkasdjflkñlaskdfj."
                        height="200px"
                        width="250px"
                        fontSize="1.3rem"
                        display="flex"
                        path={path}
                    />
                    <ArticleFolo
                        title="3 tips de carpinteria"
                        tag="carpinteria"
                        img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        author="El folo"
                        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam mollitia nihil tempora quae quas magnam voluptatibus dolorum, facere omnis consequatur minus fuga nulla ducimus dolore earum labore repudiandae illo eosasdfsadfkasjdklfjsadklñas ldñfjaklsñdjfñlkasdj fñlkasjdflkjasñdlkfjlkasdjflksadjfñklasd jñalsdkjfñlaskdjñflksjddsfsdfsdlkasdfsadfñjkkljñaslkdfjñlkasdjflkasdjflkñlaskdfj."
                        height="200px"
                        width="250px"
                        fontSize="1.3rem"
                        display="flex"
                        path={path}
                    />
                    <ArticleFolo
                        title="3 tips de carpinteria"
                        tag="carpinteria"
                        img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        author="El folo"
                        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam mollitia nihil tempora quae quas magnam voluptatibus dolorum, facere omnis consequatur minus fuga nulla ducimus dolore earum labore repudiandae illo eosasdfsadfkasjdklfjsadklñas ldñfjaklsñdjfñlkasdj fñlkasjdflkjasñdlkfjlkasdjflksadjfñklasd jñalsdkjfñlaskdjñflksjddsfsdfsdlkasdfsadfñjkkljñaslkdfjñlkasdjflkasdjflkñlaskdfj."
                        height="200px"
                        width="250px"
                        fontSize="1.3rem"
                        display="flex"
                        path={path}
                    /> path={path}
                    <ArticleFolo
                        title="3 tips de carpinteria"
                        tag="carpinteria"
                        img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        author="El folo"
                        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam mollitia nihil tempora quae quas magnam voluptatibus dolorum, facere omnis consequatur minus fuga nulla ducimus dolore earum labore repudiandae illo eosasdfsadfkasjdklfjsadklñas ldñfjaklsñdjfñlkasdj fñlkasjdflkjasñdlkfjlkasdjflksadjfñklasd jñalsdkjfñlaskdjñflksjddsfsdfsdlkasdfsadfñjkkljñaslkdfjñlkasdjflkasdjflkñlaskdfj."
                        height="200px"
                        width="250px"
                        fontSize="1.3rem"
                        display="flex"
                        path={path}
                    />
                    <ArticleFolo
                        title="3 tips de carpinteria"
                        tag="carpinteria"
                        img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        author="El folo"
                        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam mollitia nihil tempora quae quas magnam voluptatibus dolorum, facere omnis consequatur minus fuga nulla ducimus dolore earum labore repudiandae illo eosasdfsadfkasjdklfjsadklñas ldñfjaklsñdjfñlkasdj fñlkasjdflkjasñdlkfjlkasdjflksadjfñklasd jñalsdkjfñlaskdjñflksjddsfsdfsdlkasdfsadfñjkkljñaslkdfjñlkasdjflkasdjflkñlaskdfj."
                        height="200px"
                        width="250px"
                        fontSize="1.3rem"
                        display="flex"
                        path={path}
                    />
                    <ArticleFolo
                        title="3 tips de carpinteria"
                        tag="carpinteria"
                        img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        author="El folo"
                        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam mollitia nihil tempora quae quas magnam voluptatibus dolorum, facere omnis consequatur minus fuga nulla ducimus dolore earum labore repudiandae illo eosasdfsadfkasjdklfjsadklñas ldñfjaklsñdjfñlkasdj fñlkasjdflkjasñdlkfjlkasdjflksadjfñklasd jñalsdkjfñlaskdjñflksjddsfsdfsdlkasdfsadfñjkkljñaslkdfjñlkasdjflkasdjflkñlaskdfj."
                        height="200px"
                        width="250px"
                        fontSize="1.3rem"
                        display="flex"
                        path={path}
                    />
                    <ArticleFolo
                        title="3 tips de carpinteria"
                        tag="carpinteria"
                        img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        author="El folo"
                        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam mollitia nihil tempora quae quas magnam voluptatibus dolorum, facere omnis consequatur minus fuga nulla ducimus dolore earum labore repudiandae illo eosasdfsadfkasjdklfjsadklñas ldñfjaklsñdjfñlkasdj fñlkasjdflkjasñdlkfjlkasdjflksadjfñklasd jñalsdkjfñlaskdjñflksjddsfsdfsdlkasdfsadfñjkkljñaslkdfjñlkasdjflkasdjflkñlaskdfj."
                        height="200px"
                        width="250px"
                        fontSize="1.3rem"
                        display="flex"
                        path={path}
                    />
                    <ArticleFolo
                        title="3 tips de carpinteria"
                        tag="carpinteria"
                        img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        author="El folo"
                        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam mollitia nihil tempora quae quas magnam voluptatibus dolorum, facere omnis consequatur minus fuga nulla ducimus dolore earum labore repudiandae illo eosasdfsadfkasjdklfjsadklñas ldñfjaklsñdjfñlkasdj fñlkasjdflkjasñdlkfjlkasdjflksadjfñklasd jñalsdkjfñlaskdjñflksjddsfsdfsdlkasdfsadfñjkkljñaslkdfjñlkasdjflkasdjflkñlaskdfj."
                        height="200px"
                        width="250px"
                        fontSize="1.3rem"
                        display="flex"
                        path={path}
                    />
                    <ArticleFolo
                        title="3 tips de carpinteria"
                        tag="carpinteria"
                        img="https://images.pexels.com/photos/1249611/pexels-photo-1249611.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        author="El folo"
                        description="Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam mollitia nihil tempora quae quas magnam voluptatibus dolorum, facere omnis consequatur minus fuga nulla ducimus dolore earum labore repudiandae illo eosasdfsadfkasjdklfjsadklñas ldñfjaklsñdjfñlkasdj fñlkasjdflkjasñdlkfjlkasdjflksadjfñklasd jñalsdkjfñlaskdjñflksjddsfsdfsdlkasdfsadfñjkkljñaslkdfjñlkasdjflkasdjflkñlaskdfj."
                        height="200px"
                        width="250px"
                        fontSize="1.3rem"
                        display="flex"
                        path={path}
                    />
                </ArticleList>
                <div className="ad">
                    {/* <div className="fb-page"
                        data-tabs="timeline"
                        data-href="https://www.facebook.com/YoloBookStore"
                        data-width="300"
                        data-height="250"
                        data-hide-cover="false">
                    </div> */}
                    <AdImage
                        width="300px"
                        height="600px"
                    />
                    <AdImage
                        width="300px"
                        height="250px"
                    />
                    <AdImage
                        width="300px"
                        height="250px"
                    />
                    <AdImage
                        width="300px"
                        height="250px"
                    />
                    <AdImage
                        width="300px"
                        height="250px"
                    />
                </div>
            </div>
        </div>
    )
}

export default SectionArticles
